const appManagement = {
  loginName: "Login name",
  realName: "ชื่อ",
  nickName: "ชื่อเล่น",
  gender: "เพศ",
  birthDate: "วันเกิด",
  width1: "140px",
  status: "สถานะ",
  loginTime: "เวลาล็อคอินครั้งล่าสุด",
  createdOn: "เวลาที่สร้าง",
  all: "ทั้งหมด",
  enable: "ใช้งานได้",
  disable: "ใช้งานไม่ได้",
  restPassword: "รีเซ็ตรหัสผ่าน",
  restPwd: {
    updatePwdSuccess: "รีเซ็ตรหัสผ่านเสร็จสมบูรณ์",
    msg1: "รีเซ็ตรหัสผ่านเป็น 12345678"
  },
  detailDilago: {
    appTitle: "รายละเอียดผู้ใช้งาน",
    personTitle: "ข้อมูลส่วนบุคคล",
    carTitle: "รถยนต์ของผู้ใช้งาน",
    notifyTitle: "ข้อความแจ้งเตือน",
    maxSpeed: "จำกัดความเร็ว",
    securityModeAlarm: "แจ้งเตือนความปลอดภัย",
    deviceUnplugReminder: "การแจ้งเตือนการ unplug",
    safetyReminder: "การแจ้งเตือนความปลอดภัย",
    geoFenceReminder: "แจ้งเตือนการเข้า/ออกขอบเขต",
    deviceOfflineReminder: "แจ้งเตือนอุปกรณ์ออฟไลน์/ออนไลน์",
    activityReminder: "แจ้งเตือนกิจกรรม",
    systemMessage: "แจ้งเตือนของระบบ",
    overSpeedAlarm: "แจ้งเตือนความเร็วเกินกำหนด",
    open: "เปิดไดอะลอก",
    off: "ปิดไดอะลอก"
  }
} 
export default appManagement